import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { MbLogoutAdapter } from '../adapters/mb-logout.adapter'

@Injectable({
  providedIn: 'root',
})
export class MbLogoutConnector  {
  constructor (protected adapter: MbLogoutAdapter) {}

  occLogout (): Observable<any> {
    return this.adapter.load()
  }
}
